module.exports = __webpack_public_path__ + "static/media/background.62dec501.svg";